import Title from '../base/title';
import {
  brandColor,
  getClassTextForColor,
  getEditorColor,
} from '../../util/ColorUtil';
import { isItUndefined, modifyLinks } from '../../util/DataUtil';
import { useEffect, useState } from 'react';
import { cleanHTML } from '../utils/htmlUtils';

const WhyChoose = ({ data, width }) => {
  const emphasizedTextColor = getEditorColor(
    isItUndefined(data?.field_why_choose_title)
  );
  const [titleHeights, setTitleHeights] = useState([]);

  useEffect(() => {
    const calculateTitleHeights = () => {
      if (typeof window !== 'undefined') {
        const updatedTitleHeights = [];
        const titleElements = document.querySelectorAll('.item-title');
        titleElements.forEach((titleElement) => {
          updatedTitleHeights.push(titleElement.clientHeight);
        });
        setTitleHeights(updatedTitleHeights);
      }
    };
    calculateTitleHeights();
  }, [data]);

  const renderItems = (items) => {
    if (!items) {
      return null;
    }
    const rows = [];
    const itemCount = items.length;
    for (let i = 0; i < itemCount; i += 3) {
      const rowItems = items.slice(i, i + 3);
      rows.push(
        <div
          key={`row-${i}`}
          id={`row-${Math.floor(i / 3) + 1}`}
          className="row"
        >
          {rowItems.map((item, index) => {
            const rowTitleHeight = titleHeights[Math.floor(i / 3)];
            return (
              <div key={`item-${i + index}`} className="item">
                {item?.field_title_p[0]?.value && (
                  <span
                    className="item-title"
                    style={{
                      height: rowTitleHeight ? rowTitleHeight + 'px' : 'auto',
                    }}
                  >
                    {item?.field_title_p[0]?.value}
                  </span>
                )}
                <span
                  dangerouslySetInnerHTML={{
                    __html: modifyLinks(item?.field_text_p[0]?.value),
                  }}
                  className={`item-subtitle ${emphasizedTextColor ? emphasizedTextColor : ''}`}
                />
              </div>
            );
          })}
        </div>
      );
    }
    return rows;
  };

  return (
    <div
      className={
        'why-choose ' +
        getClassTextForColor(data?.field_background_color[0]?.value)
      }
      style={{
        backgroundColor: brandColor(data?.field_background_color[0]?.value),
      }}
    >
      <div className={'inner-container'}>
        <Title
          title={cleanHTML(data?.field_why_choose_title[0]?.value)}
          position={data?.field_text_position[0]?.value}
          emphasizedTextColor={emphasizedTextColor}
        />
        <div className={'items'}>
          {renderItems(data?.field_why_choose_items?.title_text_paragraph_type)}
        </div>
      </div>
    </div>
  );
};

export default WhyChoose;
